import {
	Directive, Output, EventEmitter, HostBinding, HostListener, ElementRef, Input
} from '@angular/core';
import { DragManager } from '../sharedModule/roBookModule/DragManager';
import { Subject, Subscription } from 'rxjs';
import { DOMHelper } from '../common/DOMHelper';

@Directive({
	selector: '[drag-to-scroll]'
})
export class DragToScrollDirective {
	@Output() public tapElement:EventEmitter<Element> = new EventEmitter();

	@Input() public enableAnimation:boolean = true;

	public onDrag:boolean = false;
	public startx:number;
	public starty:number;
	public diffx:number;
	public diffy:number;
	public dom:any;
	public speed:number = 0.03;
	protected timecount:number;
	protected animateTimer:number = -1;
	protected lastTime:number = 0;
	public moved = false;
	public subscription = null;

	private dd:DragManager;

	constructor(private elementRef:ElementRef)
	{
		this.dom = elementRef.nativeElement;
		this.dd = new DragManager();
	}
	
	@HostListener('touchstart', ['$event'])
	@HostListener('mousedown', ['$event'])
	startPress(e):void {
		// console.log("startPress", e);
		if (this.dom.tagName == "PERFECT-SCROLLBAR") {
			this.dom = this.dom.querySelector(".ps");
		}
		if (this.onDrag === false) {
			this.onDrag = e.offsetX <= e.target.clientWidth && e.offsetY <= e.target.clientHeight;
			this.startx = e.clientX + this.dom.scrollLeft;
			this.starty = e.clientY + this.dom.scrollTop;
			this.diffx = 0;
			this.diffy = 0;


			e.stopImmediatePropagation();
			var startTime:number = new Date().getTime();
			var moveDistance:number = 0;
			var subject:Subject<any> = e.type == "touchstart" ?  this.dd.touchStart(e) : this.dd.pointerStart(e);
			var subscription:Subscription = subject.subscribe((o:any)=>{
				
				if(o.type == "start") {
					this.moved = false;
				} else if(o.type == "move") {
					if (this.onDrag) {
						this.moved = true;
						this.diffx = (this.startx - (o.point.x + this.dom.scrollLeft));
						this.diffy = (this.starty - (o.point.y + this.dom.scrollTop));
						this.dom.scrollLeft += this.diffx;
						this.dom.scrollTop += this.diffy;
						moveDistance+=Math.sqrt(this.diffx * this.diffx + this.diffy * this.diffy);
					}
				} else if(o.type == "end" || o.type == "cancel" || o.type == "timeout") {
					if (this.moved) {
						o.event.preventDefault();
						o.event.stopPropagation();
						o.event.stopImmediatePropagation();
					}

					subscription.unsubscribe();
					this.subscription = null;

					this.onDrag = false;
					this.timecount = 1;
					if (this.enableAnimation) {
						this.updateAnimationFrame();
					}
					if(o.type == "end" && new Date().getTime() - startTime <= 250 && moveDistance <= 8) {
						this.tapElement.emit(document.elementFromPoint(o.point.x, o.point.y));
					}
				}
			});

			this.subscription = subscription;
		}
	}

	@HostListener('mouseup', ['$event'])
	@HostListener('touchend', ['$event'])
	@HostListener('touchcancel', ['$event'])
	stopPress(e): void {
		if (this.subscription && !this.enableAnimation) {
			this.subscription.unsubscribe();
			this.subscription = null;
			this.onDrag = false;
		}
	}


	protected updateAnimationFrame():void {
		var step:number = Math.sin(this.timecount)*1.1;
		if (step <= 0) {
			// 動畫完結
			this.diffx = 0;
			this.diffy = 0;
			this.onDrag = false;
			if(this.animateTimer!=-1) {
				clearTimeout(this.animateTimer);
				this.animateTimer = -1;
			}
			
		} else {
			// 餘力移動
			this.dom.scrollLeft += this.diffx * step;
			this.dom.scrollTop += this.diffy * step;
			this.timecount -= this.speed;
			
			var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - this.lastTime));
			this.lastTime = currTime + timeToCall;
            this.animateTimer = window.setTimeout(()=>{this.updateAnimationFrame();}, timeToCall);
		}
	}
}
